import TaskDossierCommentsMutations from './taskDossier/mutations'

export default {
  ...TaskDossierCommentsMutations,
}
